import React, { ReactNode } from 'react';
import styles from './ListEditItem.styles';
import ListItem from '../../components/shared/ListItem';
import { useIntl } from 'react-intl';
import { Tooltip } from 'antd';

interface Props {
  label?: ReactNode;
  leftItem: ReactNode;
  rightItem?: ReactNode;
  style?: any;
  verified?: boolean;
  onClickEdit?: () => void;
  onClickAdd?: () => void;
  hideVerified?: boolean;
  warning?: boolean;
  testid?: string;
  spanStyle?: any;
}

const ListEditItem: React.FC<Props> = ({
  label,
  leftItem,
  rightItem,
  style = {},
  verified,
  onClickEdit,
  onClickAdd,
  hideVerified = false,
  warning = false,
  testid,
  spanStyle,
}) => {
  const intl = useIntl();
  const disableEditing = verified != undefined && leftItem && verified === true;
  return (
    <>
      <ListItem
        testid={testid}
        label={label}
        value={
          <div className="wrapper">
            <span
              data-testid={`ListEditItem-inputValue-${testid}`}
              style={spanStyle}
            >
              {!hideVerified &&
                (warning || verified != undefined) &&
                leftItem &&
                (warning ? (
                  <Tooltip
                    title={intl.formatMessage({
                      id: 'fleetadmin.users.info.warning',
                      defaultMessage:
                        'Es ist ein Wert einer externen Quelle hinterlegt, der nicht mit diesem übereinstimmt.',
                    })}
                  >
                    <img
                      data-testid={`ListEditItem-warning-${testid}`}
                      className="warning-icon"
                      alt="warning"
                      src="/images/drawer/warning.svg"
                    />
                  </Tooltip>
                ) : (
                  <img
                    data-testid={
                      verified
                        ? `ListEditItem-verified-${testid}`
                        : `ListEditItem-unverified`
                    }
                    title={intl.formatMessage({
                      id: `fleetadmin.users.info.${
                        verified ? 'verified' : 'unverified'
                      }`,
                    })}
                    alt={verified ? 'verified' : 'unverified'}
                    src={`/images/drawer/${
                      verified ? 'verified_green' : 'verified_grey'
                    }.svg`}
                    style={{
                      width: 16,
                      height: 16,
                      marginRight: 4,
                      marginBottom: 2,
                    }}
                  />
                ))}
              {leftItem && leftItem}
            </span>
            {rightItem && rightItem}
            {onClickEdit != undefined && (
              <img
                data-testid={`listEditItem-editBtn-${testid}`}
                className={
                  disableEditing ? 'disabled-edit-button' : 'edit-button'
                }
                src={`/images/drawer/${
                  disableEditing ? 'disabledEdit' : 'edit'
                }.svg`}
                alt="edit"
                onClick={disableEditing ? () => {} : onClickEdit}
              />
            )}
            {onClickAdd != undefined && (
              <img
                className="add-button"
                src="/images/drawer/add.svg"
                alt="edit"
                onClick={onClickAdd}
              />
            )}
          </div>
        }
        style={style}
      />
      <style jsx>{styles}</style>
    </>
  );
};

export default ListEditItem;
